import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import jaLocale from 'element-ui/lib/locale/lang/ja'
// 引入各个语言配置文件
import zh from '../locales/zh'
import en from '../locales/en'
import ja from '../locales/ja'
Vue.use(VueI18n)

const messages = {
  en: {
    ...en,
    ...enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zh: {
    ...zh,
    ...zhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
  },
  ja: {
    ...ja,
    ...jaLocale
  }
}

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: localStorage.getItem('lang') || 'en', // 语言标识
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages
})
// 暴露i18n
export default i18n
